import React, {useState} from 'react';
import {View, Text} from 'react-native';
import {Typography} from 'src/styles';
import {DeleteModal, Modal} from 'src/design-system';
import * as Yup from 'yup';
import TagForm from '../tag-form';
import {useDatabase} from '@nozbe/watermelondb/react';
import {useSelector} from 'react-redux';
import TagTypeList from 'src/modules/organization/components/tag-type-list';
import {NestableScrollContainer} from 'react-native-draggable-flatlist';
import {Tag} from 'src/models';
import {useStyle} from 'src/providers/style';
import {RHButton} from 'src/common-components/custom-ui-helpers';
import {useTranslations} from 'src/providers/translation';

const Tags = ({role}: any) => {
  const database = useDatabase();
  const styles = useStyle();
  const translations = useTranslations();

  const tagTypes = ['Assessments', 'Skills', 'Behaviors', 'Related Services'];

  const {selectedGroup, userId} = useSelector(state => state.authentication);

  const [showDelete, setShowDelete] = useState<string | boolean>(false);
  const [show, setShow] = useState(false);
  const [tag, setTag] = useState(null);

  const addCallback = () => {
    setTag(null);
    setShow(true);
  };
  const editCallback = (entity: any) => {
    setTag(entity);
    setShow(true);
  };
  const deleteCallback = (item: any) => {
    setShowDelete(item);
  };
  const deleteCancelled = () => {
    setShowDelete(false);
  };
  const deleteConfirmed = async (item: any) => {
    item.delete();
    setShowDelete(false);
  };

  const title = tag ? translations('edit_tag') : translations('add_tag');

  const validationSchema = Yup.object({
    tagType: Yup.string().required('Tag Type is required'),
    name: Yup.string().required('A name is required'),
  });

  const navigateBack = (formik: any) => {
    formik.resetForm();
    setShow(false);
  };

  const handleSubmit = async (values: any, formik: any) => {
    if (tag) {
      tag.updateEntity(values);
    } else {
      await database.write(async () => {
        await database.get(Tag.table).create(entity => {
          entity.partition = selectedGroup;
          Object.assign(entity, values);
          entity.createdBy = userId;
          entity.updatedBy = userId;
        });
      });
    }
    navigateBack(formik);
  };

  return (
    <>
      <Modal show={[show, setShow]} title={title}>
        <TagForm
          enableReinitialize={!!tag}
          handleSubmit={handleSubmit}
          cancelled={navigateBack}
          tag={tag}
          validationSchema={validationSchema}
        />
      </Modal>
      <DeleteModal
        model={'Tag'}
        text={showDelete ? `${showDelete?.name}` : null}
        show={[showDelete, setShowDelete]}
        cancelled={() => deleteCancelled()}
        handleSubmit={() => deleteConfirmed(showDelete)}
      />
      <NestableScrollContainer
        style={[styles.flex, styles.backgroundColorWhite, styles.borderRadius]}
        contentContainerStyle={[styles.paddingVertical]}
        persistentScrollbar={true}>
        <View
          style={[
            styles.flex,
            styles.row,
            styles.justifySpaceBetween,
            styles.alignCenter,
            styles.marginBottom,
            styles.paddingHorizontal,
          ]}>
          <Text style={[Typography.H4]}>{translations('tags')}</Text>
          {role?.tagCreate ? (
            <RHButton icon={'plus'} mode="contained" onPress={addCallback}>
              {translations('add')}
            </RHButton>
          ) : (
            <></>
          )}
        </View>
        <View style={[]}>
          {tagTypes.map((tagType: any) => (
            <TagTypeList
              key={`tag-type-${tagType}`}
              tagType={tagType}
              canEdit={role?.tagEdit}
              editCallback={editCallback}
              canDelete={role?.tagDelete}
              deleteCallback={deleteCallback}
            />
          ))}
        </View>
      </NestableScrollContainer>
    </>
  );
};

export default Tags;
